export const bg = `<div class="container sm p-2 primary"> 
    .primary
</div>
<div class="container sm p-2 info"> 
    .info
</div>
<div class="container sm p-2 danger">
    .danger
</div>
<div class="container sm p-2 warning">
    .warning
</div>
<div class="container sm p-2 light">
    .light
</div>
<div class="container sm p-2 dark">
    .dark
</div>
<div class="container sm p-2 success">
    .success
</div>
<div class="container sm p-2 secondary">
    .secondary
</div>`